import {
  ComponentPropsWithoutRef,
  CSSProperties,
  PropsWithChildren,
} from 'react';
import clsx from 'clsx';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './errorMessage.module.scss';

export function ErrorMessage({
  children,
  className,
  style,
  ...props
}: PropsWithChildren & {
  className?: string;
  style?: CSSProperties;
} & ComponentPropsWithoutRef<'span'>) {
  return (
    <span className={clsx(styles['error'], className)} style={style} {...props}>
      <GoogleFontIcon
        className={styles['error__icon']}
        name="report"
        solid
        small
      />
      {children}
    </span>
  );
}
